// extracted by mini-css-extract-plugin
module.exports = {"card":"style-module__card___1qPfJ","sectionName":"style-module__sectionName___V86MU"};